import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_carousel_prev = _resolveComponent("carousel-prev")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_carousel_next = _resolveComponent("carousel-next")!
  const _component_mission_card = _resolveComponent("mission-card")!
  const _component_n_gi = _resolveComponent("n-gi")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_carousel = _resolveComponent("n-carousel")!

  return (_ctx.slideMissions.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_n_carousel, {
          class: "missions-carousel",
          "show-arrow": true
        }, {
          arrow: _withCtx(({ prev, next }) => [
            _createVNode(_component_n_button, {
              tertiary: "",
              circle: "",
              onClick: prev,
              style: {"position":"absolute","left":".5rem","top":"45%"},
              size: "large"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_n_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_carousel_prev, { style: {"color":"var(--n-arrow-color)"} })
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_n_button, {
              tertiary: "",
              circle: "",
              onClick: next,
              style: {"position":"absolute","right":".5rem","top":"45%"},
              size: "large"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_n_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_carousel_next, { style: {"color":"var(--n-arrow-color)"} })
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slideMissions, (missions, i) => {
              return (_openBlock(), _createBlock(_component_n_grid, {
                "x-gap": "24",
                cols: "12",
                "item-responsive": "",
                responsive: "screen",
                collapsed: "",
                key: i
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(missions, (mission, auxIndex) => {
                    return (_openBlock(), _createBlock(_component_n_gi, {
                      key: mission?.id,
                      span: _ctx.missionSpan
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_mission_card, {
                          mission: mission,
                          auxIndex: auxIndex
                        }, null, 8, ["mission", "auxIndex"])
                      ]),
                      _: 2
                    }, 1032, ["span"]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}